import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { ID, User } from '../models/backend';
import { ClientData, Company, Contact } from '../stores/client-data.store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyDataService {
  private http = inject(HttpClient);
  private environment = inject(ENVIRONMENT);
  readonly #COMPANIES_BASE_URL = `${this.environment.cmsApiUrl}/companies`;
  readonly #CONTACTS_BASE_URL = `${this.environment.cmsApiUrl}/contacts`;

  getAllCompanies() {
    return this.http.get<Company[]>(this.#COMPANIES_BASE_URL);
  }

  getCompanyData(id: ID | null) {
    return this.http.get<Company>(`${this.#COMPANIES_BASE_URL}/${id}`);
  }

  updateCompany(id: ID, data: Partial<Company>) {
    return this.http.put<Company>(`${this.#COMPANIES_BASE_URL}/${id}`, {
      data,
    });
  }

  updateCompanyBonuses(id: ID | undefined, data: ID[]) {
    const payload = {
      data: {
        bonuses: data,
      },
    };
    return this.http.put<Company>(`${this.#COMPANIES_BASE_URL}/${id}`, payload);
  }

  createContact(data: Contact): Observable<Contact> {
    return this.http.post(`${this.#CONTACTS_BASE_URL}`, { data: data });
  }

  updateContact(data: { contact: Contact; documentId: string }) {
    return this.http.put(`${this.#CONTACTS_BASE_URL}/${data.documentId}`, {
      data: data.contact,
    });
  }

  deleteContact(documentId: string) {
    return this.http.delete(`${this.#CONTACTS_BASE_URL}/${documentId}`);
  }
}
